module.exports = __webpack_public_path__ + "media/assets/faria_products/SIMSEPORT-c7c2f33fb62dc4929caea34e08133e47aca02ff58b6dfa796c313578b9ce0d10.png";